import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

export interface SearchResult {
  id: string
  type: 'contact' | 'interaction' | 'voice_note'
  title: string
  subtitle: string | null
  highlight: string | null
}

interface SearchResponse {
  contacts: SearchResult[]
  interactions: SearchResult[]
  voice_notes: SearchResult[]
}

export function useSearch(query: string) {
  return useQuery({
    queryKey: ['search', query],
    queryFn: () => api<SearchResponse>(`/api/search?q=${encodeURIComponent(query)}`),
    enabled: query.length >= 2,
    staleTime: 1000 * 30,
  })
}
